const TIMELINE_DATA = [

    {
        date: {
            year: 1968,
            month: 10,
            day: 24
        },
        headline: 'Woodrow Wilson Memorial Act of 1968',
        content: `
“The Congress hereby finds and declares—

(1) that a living institution expressing the ideals and concerns of Woodrow Wilson would be an appropriate memorial to his accomplishments as the twenty-eighth President of the United States, a distinguished scholar, an outstanding university president, and a brilliant advocate of international understanding; (2) that the Woodrow Wilson Memorial Commission, created by joint resolution of Congress, recommended that an International Center for Scholars be constructed in the District of Columbia in the area north of the proposed Market Square as part of the Nation's memorial to Woodrow Wilson; (3) that such a center, symbolizing and strengthening the fruitful relation between the world of learning and the world of public affairs, would be a suitable memorial to the spirit of Woodrow Wilson; and (4) that the establishment of such a center would be consonant with the purposes of the Smithsonian Institution, created by Congress in 1846 "for the increase and diffusion of knowledge among men.”
        `,
        link: 'https://www.gpo.gov/fdsys/pkg/STATUTE-82/pdf/STATUTE-82-Pg1356.pdf',
        image: ['wilson_sitting_AP.jpg'],
    },

    {
        date: {
            year: 1969,
            month: null,
            day: null
        },
        headline: 'Benjamin Read Becomes First Director of Wilson Center',
        content: `
The founding director of the Wilson Center, Benjamin Read helped determine the Center's organization and the appointments of the very first scholars. In 1973, he moved to become the president of the German Marshall Fund, continuing his important work in strengthening international cooperation and scholarship.
        `,
        link: null,
        image: ['benjamin-read.jpg'],
    },

    {
        date: {
            year: 1971,
            month: 2,
            day: 18
        },
        headline: 'The Official Dedication of the Wilson Center',
        content: `
"We have taken the first steps toward walking in peace. But we must first break the terrible world habit of war and only then can we learn the wondrous habit of peace.

That is why today I do not speak of the war to end wars. Instead, I hope to focus on something that men alive today can achieve for themselves and their children, on a dream that we can realize here and now, a genuine beginning toward our ultimate goal.

That is why I have set our sights on a span of time that men in positions of power today can cope with, just one generation, but one long step on the path away from perennial war.

That, too, is why it is more important now than ever before to summon up the spirit of Woodrow Wilson. For we can only establish the habit of peace by answering the call for human brotherhood, his inspiration for an understanding between men and nations."
---Remarks by President Richard Nixon at the Dedication of the Woodrow Wilson International Center for Scholars
        `,
        link: 'http://www.presidency.ucsb.edu/ws/index.php?pid=3313',
        image: ['nixon-wilsoncenter.jpg'],
    },

    {
        date: {
            year: 1973,
            month: null,
            day: null
        },
        headline: 'James Billington Begins Term as Director',
        content: `
Before coming to the Wilson Center, James Billington was a professor of history at Harvard and Princeton. Mr. Billington presided over the greatest period of growth in the Center's history, launching many programs, including the Kennan Institute, State and Local Government, the Latin America Program, the Environmental Studies Program, International Security Studies, the East Asia Program, and the Program on American Society and Politics. Under his leadership, the Wilson Quarterly was established. He also drastically expanded private support and donations to the Center, and put it on secure financial footing. He left in 1987 to serve as Librarian of Congress.
        `,
        link: null,
        image: ['James_Billington.jpeg', 'Moynihan Billington.jpg']

,
    },

    {
        date: {
            year: 1974,
            month: null,
            day: null
        },
        headline: 'Kennan Institute Established',
        content: `
Named in honor of Ambassador Kennan's relative, George Kennan "the Elder" (1845-1924), a nineteenth-century explorer of Russia and Siberia, the Kennan Institute is committed to improving American expertise and knowledge about Russia, Ukraine, and other states in the region.
        `,
        link: 'https://www.wilsoncenter.org/program/kennan-institute',
        image: ['georgekennan.jpeg'],
    },

    {
        date: {
            year: 1976,
            month: null,
            day: null
        },
        headline: 'The Wilson Quarterly Established',
        content: `
*The Wilson Quarterly* offers fresh takes, on-the-ground reporting, and thought-provoking perspectives through carefully curated essays. Each issue takes a deep and satisfying dive into a single topic or theme that is shaping our world - presenting a compelling range of angles and voices. Whether exploring specific regions, political developments, social trends or history, the award-winning WQ aims to inform, intrigue, and inspire.
        `,
        link: 'https://wilsonquarterly.com/',
        image: ['wilsonquarterly1976.jpg'],
    },

    {
        date: {
            year: 1977,
            month: null,
            day: null
        },
        headline: 'Latin American Program Established',
        content: `
The Latin American Program provides non-partisan expertise to a broad community of decision makers in the United States and Latin America on critical policy issues facing the Hemisphere.
        `,
        link: 'https://www.wilsoncenter.org/program/latin-american-program',
        image: [],
    },

    {
        date: {
            year: 1977,
            month: null,
            day: null
        },
        headline: 'Asia Program Established',
        content: `
The Asia Program provides a forum in the nation's capital for enhancing deeper understanding of, and policy debate about, Asia. It seeks to furnish an intellectual link between the world of ideas and the world of policy on issues relating to Asia and U.S. interests in Asia.
        `,
        link: 'https://www.wilsoncenter.org/program/asia-program',
        image: [],
    },

    {
        date: {
            year: 1977,
            month: null,
            day: null
        },
        headline: 'International Security Studies Program Established',
        content: `
The International Security Studies Program was created by Samuel Wells and General Andrew J. Goodpaster, US Army (Ret.) to study the full range of security issues involved in the United States international role.  This included military, economic, and intelligence topics, and the program devoted special emphasis to uses of recent historical experience to analyze current security issues.  In its early years the program focused several projects on the emergence of deterrence as a strategy and arms control as a new policy initiative in relations with the Soviet Union.

The start of the International Security Studies program marked the beginning of Samuel Wells' 31-year career on the staff of the Center.  He managed this program for a decade before becoming Associate Director and in 1988 was appointed Deputy Director for another ten years.  He concluded his staff service Associate Director and Director of West European Studies from 1999 to 2008.  He is currently a Cold War Fellow in the History and Public Policy Program.
        `,
        link: 'https://www.wilsoncenter.org/article/video-the-life-living-memorial',
        linkLabel: 'Watch Interview with Sam Wells',
        image: ['samwells.jpg'],
    },

    {
        date: {
            year: 1977,
            month: 12,
            day: null
        },
        headline: 'Gloria Steinem Begins Fellowship',
        content: `
Gloria Steinem, already a noted feminist thinker, joined the Center as a fellow in 1977. She intended to write a book to assess the state of womens' rights in American public policy. She noted that the center was overwhelmingly male.

In 1978, she wrote "as you can imagine, the exclusion &lbrack;of women&rbrack; was one of the reasons I chose to apply to this program above others that have already admitted women. Opening up new territory -- and not competing with other women for the stipends already available -- seems to be a function that some of us should serve...part of our function should be as catalysts."

Noting the lack of gender diversity, the Center began investing more in equalizing opportunity for female academics. Since Steinem's fellowship, the Wilson Center has increasingly welcomed esteemed female thinkers in leadership roles, fellowships, and staff positions. Three Wilson Center programs, The Global Women’s Leadership Initiative, the Maternal Health Initiative, and the Women in Public Service Project stand in part as a legacy of Steinem’s “catalyst.” Today, the Wilson Center hosts a scholar class that is 40% women, and our first woman president began her tenure in 2011.
        `,
        link: null,
        image: ['gloriasteinem.jpg'],
    },

    {
        date: {
            year: 1981,
            month: 10,
            day: null
        },
        endDate: {
            year: 1982,
            month: 8,
            day: null
        },
        headline: 'Madeleine Albright Begins Fellowship',
        content: `
Madeleine Albright, later Ambassador to the United Nations and U.S. Secretary of State, joins the Wilson Center as a History, Culture, and Society Fellow. Her project over her fellowship was "Propaganda, pragmatism, or protest--the role of the press in Eastern European Attempts at Liberalization." She followed this by becoming the first woman U.S. Secretary of State, and championing a humanistic U.S. foreign policy abroad. She said of Wilson, "Human rights, democracy and freedom should be offered, not imposed. The U.S. is most secure when it follows the principles that Wilson laid out."
        `,
        link: null,
        image: [],
    },

    {
        date: {
            year: 1983,
            month: null,
            day: null
        },
        headline: 'Radio Show Dialogue Begins',
        content: `
In 1983, the Wilson Center created the radio program DIALOGUE under Center Director James Billington. DIALOGUE brought to a national listening audience the store of knowledge and creative thinking represented by the Wilson Center’s fellows, scholars, and public figures on topics largely related to current events, international affairs, history, and culture. From 1988-2009, George Liston Seay produced and hosted the series, interviewing a wide variety of people over a total of 960 episodes of the radio show.
        `,
        link: null,
        image: [],
    },

    {
        date: {
            year: 1987,
            month: null,
            day: null
        },
        headline: 'Center Director Charles Blitzer Begins Term',
        content: `
A founder of the Wilson Center, Charles Blitzer left to be an official with the greater Smithsonian Institution. Returning in 1987, he oversaw the move from the Smithsonian Castle to the Ronald Reagan building, as well as revitalized the Wilson Quarterly. Under his leadership, the Center hosted many distinguished fellows, from Secretary Madeleine Albright to sociologist and "leading theorist of democracy and American exceptionalism" Seymour Martin Lipset, to Pulitzer Prize-winning journalist Neil Sheehan, publisher of the Pentagon Papers.
        `,
        link: null,
        image: ['blitzerandgroup.jpg'],
    },

    {
        date: {
            year: 1988,
            month: null,
            day: null
        },
        endDate: {
            year: 1989,
            month: null,
            day: null
        },
        headline: 'Thomas Friedman, then the Chief Diplomatic Correspondent of the New York Times, completed his best-selling book, From Beirut to Jerusalem, while serving as a Guest Scholar.',
        content: null,
        link: null,
        image: ['thomas-friedman.jpg'],
    },

    {
        date: {
            year: 1988,
            month: null,
            day: null
        },
        headline: 'President George H. W. Bush celebrates 20 years of the Wilson Center',
        content: `
        Bush, 41, delivers the address for the Center's 20th anniversary
        `,
        link: null,
        image: ['bush_20th.jpg'],
    },

    {
        date: {
            year: 1988,
            month: null,
            day: null
        },
        endDate: {
            year: 2009,
            month: null,
            day: null
        },
        headline: 'George Liston Seay began his Legendary Career as Host of Dialogue',
        content: `
George had the longest tenure of any staff member at the Wilson Center--33 years--as a special assistant to the director, as the Center’s congressional liaison, and as director of development for more than a decade. He began his award-winning work on dialogue in 1988, armed simply with a handheld tape recorder and a fascination with the art of conversation.

"&lbrack;The&rbrack; dialogue &lbrack;series&rbrack; has been my life," Seay once said. "Conversation is an art that we have largely neglected in modern society—it's one of the best aspects of life."

What made George so unique among interviewers was the intense research he conducted on his subjects and topics prior to his interviews, which generated thoughtful and inquisitive conversations. His subjects consistently said they were awed by George's intellect, passion, and modesty.

"Never take the person sitting next to you for granted," he once said. "When you get started in a conversation with somebody new, it's like discovering a whole new world. We're surrounded by remarkable people."
`
    ,
        link: null,
        image: ['dialogueradio.jpg'],
    },

    {
        date: {
            year: 1991,
            month: null,
            day: null
        },
        headline: 'Cold War International History Project (CWIHP) established',
        content: `
The Project supports the full and prompt release of historical materials by governments on all sides of the Cold War, and seeks to accelerate the process of integrating new sources, materials and perspectives from the former "Communist bloc" and the non-Western world more generally with the historiography of the Cold War which has been written over the past few decades largely by Western scholars reliant on Western archival sources. The program was started by four former Wilson Center Fellows: John Lewis Gaddis, William Taubman, Warren Cohen, and Samuel Wells.  Both Gaddis and Taubman later won Pulitzer Prizes for important biographies they worked on while at the Center; Gaddis on George F. Kennan and Taubman on Nikita Khrushchev.
        `,
        link: 'https://www.wilsoncenter.org/program/cold-war-international-history-project',
        image: [],
    },

    {
        date: {
            year: 1991,
            month: null,
            day: null
        },
        headline: 'Urban Sustainability Laboratory Established',
        content: `
The Wilson Center's Urban Sustainability Laboratory (USL) researches and programs to promote inclusive and livable cities. Moving forward, the Laboratory will develop learning exchanges that advance comprehensive and integrated policies, public-private partnerships, strategic long-term city planning and sustainable models for managing urban development by strengthening governance structures and engaging civil society.
        `,
        link: 'https://www.wilsoncenter.org/program/urban-sustainability-laboratory',
        image: [],
    },

    {
        date: {
            year: 1992,
            month: null,
            day: null
        },
        endDate: {
            year: 1993,
            month: null,
            day: null
        },
        headline: 'Joseph S. Nye, Jr Joins the Wilson Center as Fellow',
        content: `
The esteemed political scientist Joseph Nye worked on a project titled “American Interest in a New World Order” while a fellow at the Center.'
`,
    link: null,
    image: ['josephnye.jpg'],
    },

    {
        date: {
            year: 1994,
            month: null,
            day: null
        },
        headline: 'Environmental Change and Security Program (ECSP) Established',
        content: `
Since 1994, the Environmental Change and Security Program (ECSP) has actively pursued the connections between the environment, health, population, development, conflict, and security.
        `,
        link: 'https://www.wilsoncenter.org/program/environmental-change-and-security-program',
        image: [],
    },

    {
        date: {
            year: 1994,
            month: null,
            day: null
        },
        headline: 'President Bill Clinton Signs into Law a Bill Naming the Woodrow Wilson Plaza, which faces the new building, then under construction',
        content: null,
        link: null,
        image: ['Clinton.jpg', 'reagan bulding.jpeg'],
    },

    {
        date: {
            year: 1997,
            month: null,
            day: null
        },
        headline: 'China Environment Forum Established',
        content: `
The China Environment Forum (CEF) has implemented projects, workshops, and exchanges that bring together U.S., Chinese, and other environmental policy experts to explore the most imperative environmental and sustainable development issues in China and to examine opportunities for business, governmental, and nongovernmental communities to collaboratively address these issues.
`,
        link: 'https://www.wilsoncenter.org/program/china-environment-forum',
        image: [],
    },

    {
        date: {
            year: 1998,
            month: null,
            day: null
        },
        headline: 'Middle East Program Established',
        content: `
The Middle East Program combines the intellectual grounding of its scholars with the power of its convening space to generate practical ideas for policymakers around the world regarding issues in the wider Middle East and North Africa (MENA) region.
`,
        link: 'https://www.wilsoncenter.org/program/middle-east-program',
        image: [],
    },

    {
        date: {
            year: 1998,
            month: null,
            day: null
        },
        headline: 'The Wilson Center Finds its Permanent Home on Pennsylvania Avenue',
        content: `
Three decades after its founding, the Wilson Center had grown out of its initial housing. The Center, which once fit comfortably in the Smithsonian Castle, now found that its growth was being limited by its environment. Splitting staff and resources between the Castle and rented offices in Southwest DC, the Center needed a change. Indeed, then-Director Charles Blitzer noted in 1988--ten years earlier--that the Center must "find a permanent home suited to its needs and appropriate to its status as a memorial to our twenty-eighth president." In the summer of 1998, that dream was a reality, when the Wilson Center moved into its permanent home on Pennsylvania Avenue.
`,
        link: null,
        image: ['Wilson-Center-Building-9.jpg', 'memorialhall.jpg'],
    },

    {
        date: {
            year: 1999,
            month: null,
            day: null
        },
        headline: 'Africa Program Established',
        content: `
The Africa Program works to address the most critical issues facing Africa and U.S.-Africa relations, build mutually beneficial U.S.–Africa relations, and enhance understanding about Africa in the United States. The Africa Program focuses on four core issues: inclusive governance and leadership; conflict prevention, peacebuilding, and security; trade, investment and sustainable development; and Africa’s evolving role in the global arena.
`,
        link: 'https://www.wilsoncenter.org/program/africa-program',
        image: [],
    },

    {
        date: {
            year: 1999,
            month: null,
            day: null
        },
        headline: 'Lee Hamilton Joins the Center as Director',
        content: `
Lee Hamilton was the first politician to lead the Wilson Center. Prior to joining the Center, he represented Indiana's 9th district for 34 years, from 1965-1999. During his tenure, he also served as a co-chair of the 9/11 Commission and the Iraq Study Group. He oversaw the creation of new programs at the Center including the Middle East Program, the Africa Program, the Science and Technology Innovation Program, and the Kissinger Institute on China and the United States.
`,
        link: null,
        image: ['lee_hamilton_smile.jpg'],
    },

    {
        date: {
            year: 2001,
            month: null,
            day: null
        },
        headline: 'Canada Institute Established',
        content: `
The Canada Institute is the only organization in the world dedicated to the advancement of the Canada-U.S. relationship across a full spectrum of issues from economics to security.

        `,
        link: 'https://www.wilsoncenter.org/program/canada-institute',
        image: [],
    },

    {
        date: {
            year: 2001,
            month: 1,
            day: null
        },
        headline: 'Daniel Patrick Moynihan Comes Home to Begin Fellowship',
        content: `
Senator Moynihan began his appointment at the Woodrow Wilson Center upon his retirement from the United States Senate in January, 2001. But his association with the Center started at its beginning.

Senator Moynihan served on the Woodrow Wilson Memorial Study Commission in the administration of John F. Kennedy, which conceptualized the Center as an institution that would memorialize President Wilson by strengthening relations between the world of scholarship and world of public affairs. Senator Moynihan then helped craft the legislation that created the Center in 1968, and was appointed by President Lyndon Johnson as the first Vice Chairman of the Center’s Board of Trustees.

For some four decades, he was the leading force behind the historic redevelopment of Pennsylvania Avenue between the White House and the Capitol in Washington D.C., and later promoted the construction of the Ronald Reagan Building, which provided a fitting permanent home for the Center.
        `,
        link: null,
        image: ['daniel_patrick_moynihan_plaza.jpg'],
    },

    {
        date: {
            year: 2003,
            month: null,
            day: null
        },
        headline: 'Mexico Institute Established',
        content: `
The Mexico Institute seeks to improve understanding, communication, and cooperation between Mexico and the United States by promoting original research, encouraging public discussion, and proposing policy options for enhancing the bilateral relationship. The Institute maintains an ongoing focus on five key issues in U.S.-Mexico relations: security and the rule of law; economics and competitiveness; migration and migrants; border issues, and energy.

        `,
        link: 'https://www.wilsoncenter.org/program/mexico-institute',
        image: [],
    },

    {
        date: {
            year: 2006,
            month: null,
            day: null
        },
        headline: 'Brazil Institute Established',
        content: `
The Brazil Institute seeks to foster dialogue on key issues of bilateral concern between Brazil and the United States and advance Washington’s understanding of contemporary Brazilian developments by promoting research, analysis and debate of Brazil’s public policies. The Brazil Institute was created out of the conviction that Brazil and the U.S.-Brazilian relationship deserve greater attention within the Washington policy community.
        `,
        link: 'https://www.wilsoncenter.org/program/brazil-institute',
        image: [],
    },

    {
        date: {
            year: 2008,
            month: null,
            day: null
        },
        headline: 'Kissinger Institute on China and the United States Established',
        content: `
A comprehensive approach to U.S.-China policy must be based not only on American interests, but on an understanding of the cultural foundations of Chinese strategy as well. The Kissinger Institute’s mission is to ensure that informed engagement remains the cornerstone of U.S.-China relations.
        `,
        link: 'https://www.wilsoncenter.org/program/north-korea-international-documentation-project',
        image: [],
    },

    {
        date: {
            year: 2009,
            month: null,
            day: null
        },
        headline: 'Science and Technology Innovation Program established',
        content: `
Our science and technology policy experts translate complexity, and explore converging and emerging technologies to maximize benefits and minimize risks. STIP focuses on the point where new technology and existing political, social, and cultural processes converge.
        `,
        link: 'https://www.wilsoncenter.org/program/science-and-technology-innovation-program',
        image: [],
    },

    {
        date: {
            year: 2010,
            month: null,
            day: null
        },
        headline: 'Jane Harman Begins Term as First Female Director',
        content: `
Jane Harman, the Director, President and CEO of the Wilson Center, is an internationally recognized authority on U.S. and global security issues, foreign relations and lawmaking. A native of Los Angeles and a public-school graduate, she went on to become a nine-term member of Congress, serving decades on the major security committees in the House of Representatives. Drawing upon a career that has included service as President Carter’s Secretary of the Cabinet and hundreds of diplomatic missions to foreign countries, Harman holds posts on nearly a dozen governmental and non-governmental advisory boards and commissions.
        `,
        link: null,
        image: ['janeharman.jpg'],
    },

    {
        date: {
            year: 2011,
            month: null,
            day: null
        },
        headline: 'The Women in Public Service Project established',
        content: `
The Women in Public Service Project empowers the next generation of women around the world and mobilizes them on issues of critical importance in public service. Through research, partnerships, and peer-to-peer networking, WPSP is pursuing the goal of “50X50”: 50% representation of women in all elected and appointed policy and political leadership positions by 2050.
        `,
        link: 'http://www.50x50movement.org/',
        image: [],
    },

    {
        date: {
            year: 2015,
            month: null,
            day: null
        },
        headline: 'Hyundai Motor-Korea Foundation Center for Korean History and Public Policy established',
        content: `
The Hyundai Motor-Korea Foundation Center for Korean History and Public Policy was established in 2015 with the generous support of the Hyundai Motor Company and the Korea Foundation to provide a coherent, long-term platform for improving historical understanding of Korea and informing the public policy debate on the Korean peninsula in the United States and beyond. The Center brings Korea to Washington through advanced research and programming that is rooted in history, informed by scholarship, and in touch with policy.
        `,
        link: 'https://www.wilsoncenter.org/program/hyundai-motor-korea-foundation-center-for-korean-history-and-public-policy',
        image: [],
    },

    {
        date: {
            year: 2018,
            month: null,
            day: null
        },
        headline: 'The Wilson Center Celebrates 50 years',
        content: `
The Wilson Center marked 50 years of impact on September 13, honoring former Secretary of State Henry Kissinger, Senator Roy Blunt (R-MO), and Congressman Steny Hoyer (D-MD) at a golden anniversary dinner in Washington, DC.
        `,
        link: null,
        image: ["kissinger_stape_award.jpg", "blunt_hoyer.jpg"],
    },

]

export default TIMELINE_DATA
